import http from 'hub-http/clients/apiClient';
export const getHubInfo = hubId => http.get(`hubs/v1/hubs/${hubId}`);